let config = require('../../package.json');

export const environment = {
  production: false,
  version: config.version,
  product: config.name,
  title: config.title,
  homepage: config.homepage,
  description: config.description,
  homecomponent: config.homecomponent,
  api: 'https://sarutech.com/api',
  analytics: config.analytics,
};
